/**
 * Extracts data-test-id and data-test-class from a props object,
 * returning only those attributes as a safe DOM-spreadable object.
 * @param {Object} props
 * @returns {{ "data-test-id"?: string, "data-test-class"?: string }}
 */
export function getDataTestAttribute(props) {
	const result = {};
	if (props["data-test-id"]) {
		result["data-test-id"] = props["data-test-id"];
	}
	if (props["data-test-class"]) {
		result["data-test-class"] = props["data-test-class"];
	}
	return result;
}